// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Create-Plan-Map[data-v-9c37dac8] {\n  width: auto;\n}\n.Create-Plan-Map .CPM[data-v-9c37dac8] {\n    width: auto;\n    height: 95vh;\n}\n[data-v-9c37dac8] .anchorBL {\n  display: none !important;\n}\n", ""]);
// Exports
module.exports = exports;
